class PanoTagZIndexManagerZIndexManager {
  constructor() {
    /**
     * 控制信息牌展示的距离大小
     */
    this.displayDistance = 8;
    /**
     * 当前实例
     */
    this.panoComponent = null;
    /**
     * 信息牌缓存
     */
    this.elementCache = new Array();
  }

  /**
   * 注册信息牌元素等信息
   * @param el
   * @param position
   */
  register(el, position) {
    this.elementCache.push({ el, position: position, distance: 0, zIndex: 0 });
  }
  /**
   * 构建信息牌的样式
   * @param distance
   * @returns
   */
  buildStyle(distance) {
    // const scale = 1.25 - distance / 15;
    // const translateX = -50;
    const translateY = -100;
    // scale(${scale})
    // translateY(${translateY}%)
    // translateX(${translateX}%)
    return {
      display: distance > this.displayDistance ? 'none' : 'block',
      transform: `perspective(2828.5px)
      translateY(${translateY}%)
      translateZ(${1250 - distance * 100}px)`,
      transformStyle: 'preserve-3d',
      'margin-top': '-48px',
      'margin-left': '-96px',
    };
  }
  /**
   * 设置信息牌样式
   * @param el
   * @param style
   */
  css(el, style) {
    for (const key in style) {
      el.style.setProperty(key, style[key]);
    }
  }

  /**
   * 设置信息牌容器的zIndex
   * @param el
   * @param zIndex
   */
  setContainerZIndex(el, zIndex) {
    if (el && el.parentElement) {
      const current = el.parentElement;
      current.style.zIndex = zIndex.toString();
    }
  }
  /**
   * 设置pano组件
   * @param panoComponent
   */
  setPanoComponent(panoComponent) {
    if (!this.panoComponent) {
      this.panoComponent = panoComponent;
      const player = panoComponent.kankan.core.get('Player');
      let app = panoComponent.kankan;
      player.on('update', () => {
        this.panoUpdateHandler(app);
      });
    }
  }
  /**
   *  pano更新处理函数
   * @param app
   */
  panoUpdateHandler(app) {
    if (app) {
      // const target = app.core.get('Player').camera.position;
      const activeControl = app.core.get('Player').cameraControls.activeControl;
      const target = activeControl.target;
      this.elementCache.forEach((item) => {
        const pos = item.position;
        const vector3 = new window.THREE.Vector3(pos.x, 0, pos.z);
        item.distance = Math.abs(
          vector3.distanceTo(new window.THREE.Vector3(target.x, 0, target.z)),
        );
        const style = this.buildStyle(item.distance);
        this.css(item.el, style);
      });
      this.elementCache
        .sort((a, b) => b.distance - a.distance)
        .forEach((item, index) => {
          item.zIndex = index + 1;
          this.setContainerZIndex(item.el, item.zIndex);
        });
    }
  }
}

const panoTagZIndexManager = new PanoTagZIndexManagerZIndexManager();
export { panoTagZIndexManager };
